import React, { useState } from "react";
import api from "@/lib/api";
import { track } from "@/lib/track";
import { COOPERACAO } from "@/content/site";

const field = "w-full bg-transparent border-b border-[#2c4a3c] focus:border-[#C7A659] outline-none py-3 font-sans font-light text-[15px] text-[#F2EFE5] placeholder:text-[#5A6859] transition-colors";
const empty = { name: "", email: "", subject: "", message: "", website: "" };

// Formulário de contato — principal meio de contato do site.
const ContactForm = ({ source = "home" }) => {
    const [f, setF] = useState(empty);
    const [state, setState] = useState("idle");
    const [error, setError] = useState("");
    const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setState("sending");
        setError("");
        try {
            await api.post("/contact", { ...f, source });
            track("contact_submit", { source });
            setState("sent");
            setF(empty);
        } catch (err) {
            const d = err?.response?.data?.detail;
            setError(typeof d === "string" ? d : "Não foi possível enviar agora. Tente novamente em instantes.");
            setState("idle");
        }
    };

    if (state === "sent") {
        return (
            <div data-testid="contact-success" className="border border-[#C7A659]/40 bg-[#14271f]/40 p-8">
                <p className="font-serif font-light text-[22px] text-[#F2EFE5]">Mensagem recebida.</p>
                <p className="mt-3 font-sans font-light text-[14px] text-[#B0B6A6]">Obrigada pelo contato. A resposta será enviada para o e-mail informado.</p>
                <button type="button" data-testid="contact-send-another" onClick={() => setState("idle")} className="mt-6 font-sans text-[11px] uppercase tracking-[0.22em] text-[#C7A659] hover:text-[#e2c886]">
                    Enviar outra mensagem
                </button>
            </div>
        );
    }

    return (
        <form onSubmit={submit} data-testid="contact-form" className="flex flex-col gap-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <input required maxLength={120} data-testid="contact-name" placeholder="Nome" value={f.name} onChange={set("name")} className={field} />
                <input required type="email" maxLength={200} data-testid="contact-email" placeholder="E-mail" value={f.email} onChange={set("email")} className={field} />
            </div>
            <input required maxLength={200} data-testid="contact-subject" placeholder="Assunto" value={f.subject} onChange={set("subject")} className={field} />
            <textarea required rows={5} maxLength={5000} data-testid="contact-message" placeholder="Mensagem" value={f.message} onChange={set("message")} className={`${field} resize-none leading-[1.7]`} />
            <input tabIndex={-1} autoComplete="off" aria-hidden="true" value={f.website} onChange={set("website")} className="hidden" name="website" />
            {error && <p data-testid="contact-error" className="font-sans text-[13px] text-[#d9a46b]">{error}</p>}
            <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:justify-between">
                <p className="font-sans font-light text-[11.5px] text-[#7E8978] max-w-xs">{COOPERACAO.privacidade}</p>
                <button type="submit" disabled={state === "sending"} data-testid="contact-submit" className="inline-flex items-center justify-center gap-3 rounded-full bg-[#C7A659] text-[#0A1812] px-8 py-3.5 font-sans text-[11.5px] uppercase tracking-[0.2em] hover:bg-[#d8bb76] disabled:opacity-60 transition-colors">
                    {state === "sending" ? "Enviando…" : "Enviar mensagem"} <span aria-hidden="true">→</span>
                </button>
            </div>
        </form>
    );
};

export default ContactForm;
